import {IRemoteExceptionDescription} from './IRemoteExceptionDescription';

export enum EXCEPTION_TYPE {
  VALIDATION_EXCEPTION = 'VALIDATION_EXCEPTION',
  UNAUTHENTICATED_EXCEPTION = 'UNAUTHENTICATED_EXCEPTION',
  NOT_FOUND_HTTP_EXCEPTION = 'NOT_FOUND_HTTP_EXCEPTION',
  UNKNOWN_SERVER_EXCEPTION = 'UNKNOWN_SERVER_EXCEPTION',
  BAD_REQUEST_EXCEPTION = 'BAD_REQUEST_EXCEPTION',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_EXCEPTION = 'UNKNOWN_EXCEPTION',
  NEED_FILL_CONTRACTOR_REQUISITES_EXCEPTION = 'NEED_FILL_CONTRACTOR_REQUISITES_EXCEPTION',
  ENTITY_CANNOT_BE_DELETED = 'ENTITY_CANNOT_BE_DELETED',
}

/**
 * Ошибка, которая приходит в результате упавшего запроса.
 */
export interface BaseException {
  error_data?: unknown;
  error_type: EXCEPTION_TYPE;
  exception: IRemoteExceptionDescription;
}
